export default {
  meta: {
    title: '聚合demo',
  },
};
